import { render, staticRenderFns } from "./SunshineSummary.vue?vue&type=template&id=bd6a0e08"
import script from "./SunshineSummary.vue?vue&type=script&lang=js"
export * from "./SunshineSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports